module.exports = __webpack_public_path__ + "static/media/matic.cf1d0a20.png";